import React, { useEffect, useRef, useState } from "react";
import FormUI from '@/componentsUI/Form';
import { feedback } from "@/utils/feedback";
import { useTranslationPlus } from "@/Core/i18n/useTranslationPlus";
import {
  useWalletAll,
  useWalletWithdrawFlat,
  useWithdrawFlat,
} from "@/store/walletStore";
import { useUserInfo } from "@/store/userInfo";
import FromItemPlus from "@/components/FormItemPlus/FromItemPlus";
import WidthdrawCurrency from "../compoments/widthdrawCurrency/WidthdrawCurrency";
import LoadingUI from "@/componentsUI/LoadingUI/LoadingUI";
import { IFInitWalletWithdrawFlatReq } from "@/api/apiReq/IFWalletReq";
import { sys } from "@/Core/utils/system";
import WidthdrawPix from "../pix/WidthdrawPix";
import {
  IFInitWalletRsp,
  IFInitWalletWithdrawFlatRsp,
} from "@/api/apiRsp/IFWalletRsp";
import ButtonUI from "@/componentsUI/Button";
import "../index.less";
import useDialogManager from "@/utils/useDialogManager";
import {
  AmountMultiplierConversion,
  dealAmount9Valid,
} from "@/Core/utils/currencyDealCenter";
import useDialog from "@/utils/useDialog";
import InternalWithdrawWayField from "../compoments/widthdrawWay/InternalWithdrawWayField";
import WidthdrawedPix from "../pix/WidthdrawedPix";
import MobileInput from "../compoments/mobileInput/MobileInput";
import { getWithdrawalMobile } from "@/utils/mobileUtils";
import BankSelector from "../compoments/bankSelector/BankSelector";
import PaymentMethodSelector from "../../../shared/PaymentMethodSelector";
import WithdrawConfirmModal from "../compoments/WithdrawConfirmModal/WithdrawConfirmModal";
import {
  getWithdrawBankInfo,
  saveWithdrawBankInfo,
} from "../withdrawStorage";
import { runWithdrawalOfficialAppPrompt } from "@/features/install/withdrawalOfficialAppPrompt";

const FlatWithdrawGhana = () => {
  const [form] = FormUI.useForm();
  const { t } = useTranslationPlus();
  const { data: wallets } = useWalletAll();
  const { data: userInfo } = useUserInfo();
  const formValidateRef = useRef(null);
  const [params, setParams] = useState<IFInitWalletWithdrawFlatReq>(
    wallets?.flat
      ? {
          currencyType:
            wallets?.flat[0]?.serverCurrencyType ||
            wallets?.flat[0]?.currencyType,
          device: sys.device,
        }
      : null
  );
  const { data, isValidating, error, mutate } = useWithdrawFlat(params);
  const [currentWallet, setCurrentWallet] = useState<IFInitWalletRsp>(
    wallets?.flat?.[0]
  );

  const [widthdrawConfig, setWidthdrawConfig] =
    useState<IFInitWalletWithdrawFlatRsp>();

  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [pendingWithdrawData, setPendingWithdrawData] = useState(null);
  const [bankType, setBankType] = useState("");
  const [selectedBank, setSelectedBank] = useState(null);
  const [availableChannels, setAvailableChannels] = useState<number[]>([]);
  const [ghanaBankCode104, setGhanaBankCode104] = useState<any[] | null>(null);

  const [selectedWithdrawType, setSelectedWithdrawType] = useState<number>(104);

  useEffect(() => {
    if (availableChannels.length === 0) {
      return;
    }

    if (!availableChannels.includes(selectedWithdrawType)) {
      setSelectedBank(null);
      form.setFieldValue("bankCode", undefined);
      return;
    }

    const bankInfo = getWithdrawBankInfo(userInfo?.userId);
    if (bankInfo?.bank && bankInfo.withdrawType === selectedWithdrawType) {
      setSelectedBank(bankInfo.bank);
      form.setFieldValue("bankCode", bankInfo.bank.code);
    } else {
      setSelectedBank(null);
      form.setFieldValue("bankCode", undefined);
    }
  }, [form, selectedWithdrawType, availableChannels, userInfo?.userId]);

  useEffect(() => {
    if (
      ghanaBankCode104 ||
      selectedWithdrawType !== 104 ||
      !availableChannels.includes(104)
    ) {
      return;
    }
    let isMounted = true;
    import(
      /* webpackChunkName: "bankcode-104-gh" */
      "../assets/gh/Bankcode-104.json"
    )
      .then((mod) => {
        if (isMounted) {
          setGhanaBankCode104(mod.default || mod);
        }
      })
      .catch((error) => {
        console.error("Failed to load Ghana Bankcode-104:", error);
      });
    return () => {
      isMounted = false;
    };
  }, [availableChannels, ghanaBankCode104, selectedWithdrawType]);

  function changeWidthdraw(index) {
    const item = wallets.flat?.[index];
    if (!item) {
      return;
    }
    setParams({
      currencyType: item.serverCurrencyType || item.currencyType,
      device: sys.device,
    });
    setCurrentWallet(item);
  }

  useEffect(() => {
    if (wallets?.flat?.length) {
      form.setFieldValue("walletType", wallets?.flat?.[0]?.currencyType);
    }
  }, [wallets]);

  useEffect(() => {
    form.setFieldValue(
      "mobile",
      getWithdrawalMobile(userInfo?.mobile, userInfo?.userId)
    );
  }, [userInfo]);

  const { trigger } = useWalletWithdrawFlat();
  const { openGoogleTowFactor } = useDialogManager();
  const { closeAll } = useDialog();

  const getFilteredWithdrawChannels = (): string[] => {
    const config = data?.configParams?.find((c) => c.withdrawType === 102);
    const accountType = config?.options?.accountType;
    if (!accountType) {
      return [];
    }
    if (Array.isArray(accountType)) {
      return accountType;
    }
    if (typeof accountType === "string") {
      return accountType.split(",").map((item) => item.trim());
    }
    return [];
  };

  const pixWidthdraw = (v) => {
    if (selectedWithdrawType === 104 && !selectedBank) {
      feedback.error(t("Wallet.Please select bank"));
      return;
    }
    if (selectedWithdrawType === 102 && !bankType) {
      feedback.error(t("Wallet.Please select a method"));
      return;
    }

    const cpf = v?.cpf?.replaceAll(".", "").replaceAll("-", "");
    const currentAccountType =
      selectedWithdrawType === 104 ? selectedBank?.code : bankType;

    const accountInfo: any = {
      pixFullName: v.userInfo?.fullName || v.accountName,
      pixCpf: cpf,
      pixType: currentAccountType,
      pixAccount: cpf,
      bankCode: currentAccountType,
    };

    if (v.userInfo?.email && v.userInfo.email.trim() !== "") {
      accountInfo.email = v.userInfo.email;
    }

    const selectedWallet = wallets?.flat?.find(
      (wallet) => wallet.currencyType === v.walletType
    );

    const requestParams = {
      currencyType:
        selectedWallet?.serverCurrencyType || v.walletType,
      money: AmountMultiplierConversion(Math.floor(v.amount), {
        currencyType: selectedWallet?.currencyType,
        serverCurrencyType: selectedWallet?.serverCurrencyType,
      }),
      withdrawType: selectedWithdrawType,
      accountInfo: JSON.stringify(accountInfo),
      accountType: currentAccountType,
      mobile: v.mobile || "",
      withdrawMobileUserId: userInfo?.userId,
    };
    trigger(requestParams)
      .then((res) => {
        const saveWithdrawInfo = () => {
          if (selectedWithdrawType === 104) {
            const bankInfo = {
              bank: selectedBank,
              withdrawType: selectedWithdrawType,
            };
            saveWithdrawBankInfo(bankInfo, userInfo?.userId);
          } else if (selectedWithdrawType === 102) {
            const bankInfo = {
              bankType: bankType,
              withdrawType: selectedWithdrawType,
            };
            saveWithdrawBankInfo(bankInfo, userInfo?.userId);
          }
        };

        if (res?.googleAuth) {
          openGoogleTowFactor({
            trigger: trigger,
            params: requestParams,
            complete: () => {
              saveWithdrawInfo();
              closeAll();
            },
          });
        } else {
          saveWithdrawInfo();
          closeAll();
        }
      })
      .catch((e) => {
        if (e?.code == "ERROR_60028") {
          if (e?.data?.withdrawAmount == 0) {
            feedback.error(
              t("WITHDRAW_NEED_BET", {
                betCode: dealAmount9Valid(e?.data?.betTarget, {
                  currencyType: e?.data?.currency,
                }),
              })
            );
          } else {
            feedback.error(
              t("WITHDRAW_ALREADY_BET", {
                alreadyCode: dealAmount9Valid(e?.data?.withdrawAmount, {
                  currencyType: e?.data?.currency,
                }),
              })
            );
          }
        } else {
          feedback.error(t(e?.code));
        }
      });
  };

  const onClickWidthdraw = () => {
    if (selectedWithdrawType === 104) {
      if (!selectedBank) {
        feedback.error(t("Wallet.Please select a bank"));
        return;
      }
    } else if (selectedWithdrawType === 102) {
      if (!bankType) {
        feedback.error(t("Wallet.Please select a method"));
        return;
      }
    }

    formValidateRef.current = true;
    form
      .validate()
      .then((v) =>
        runWithdrawalOfficialAppPrompt({
          stage: "before_submit",
          userId: userInfo?.userId,
          onContinue: () => {
            setPendingWithdrawData(v);
            setShowConfirmModal(true);
          },
        }),
      )
      .finally(() => {
        formValidateRef.current = false;
      });
  };

  function changeType({ data }) {
    setWidthdrawConfig(data);
  }

  const handleWithdrawConfirm = (confirmData: {
    fullName: string;
    email?: string;
  }) => {
    if (pendingWithdrawData) {
      const enhancedData = {
        ...pendingWithdrawData,
        userInfo: confirmData,
      };
      pixWidthdraw(enhancedData);
    }
    setShowConfirmModal(false);
    setPendingWithdrawData(null);
  };

  const handleWithdrawClose = () => {
    setShowConfirmModal(false);
    setPendingWithdrawData(null);
  };

  useEffect(() => {
    if (data && data?.configParams) {
      const channels = data.configParams.map((config) => config.withdrawType);
      const only104Channels = channels.filter((type) => type === 104);
      const effectiveChannels =
        only104Channels.length > 0 ? only104Channels : channels;
      setAvailableChannels(effectiveChannels);

      let savedTypeNum: number | null = null;
      let savedBankType: string | null = null;
      const bankInfo = getWithdrawBankInfo(userInfo?.userId);
      if (bankInfo) {
        savedTypeNum = bankInfo.withdrawType;
        savedBankType = bankInfo.bankType;
      }

      let initialType: number;
      if (effectiveChannels.includes(104)) {
        initialType = 104;
      } else if (savedTypeNum && effectiveChannels.includes(savedTypeNum)) {
        initialType = savedTypeNum;
      } else {
        initialType = effectiveChannels[0] || data.configParams[0].withdrawType;
      }

      setSelectedWithdrawType(initialType);

      const initialConfig =
        data.configParams.find(
          (config) => config.withdrawType === initialType
        ) || data.configParams[0];

      form.setFieldValue("witdrawWay", {
        type: initialConfig.withdrawType,
        data: initialConfig,
      });
      setWidthdrawConfig(initialConfig);

      if (initialType === 102) {
        const config102 = data.configParams.find(
          (config) => config.withdrawType === 102
        );
        const accountTypeOptions = config102?.options?.accountType as
          | string
          | string[]
          | undefined;
        let defaultBankType = "";

        if (savedBankType && savedTypeNum === 102) {
          defaultBankType = savedBankType;
        } else if (accountTypeOptions) {
          if (typeof accountTypeOptions === "string") {
            defaultBankType = accountTypeOptions.split(",")[0]?.trim() || "";
          } else if (Array.isArray(accountTypeOptions)) {
            defaultBankType = accountTypeOptions[0];
          }
        }
        setBankType(defaultBankType);
      }
    }
  }, [data, userInfo?.userId]);

  const handleBankSelect = (bank) => {
    setSelectedBank(bank);
    if (bank) {
      form.setFieldValue("bankCode", bank.code);
    }
  };

  return (
    <div className="flat-widthdraw">
      <FormUI form={form} layout={"vertical"} autoComplete={"off"}>
        <FromItemPlus
          field={"walletType"}
          label={t("Wallet.WithdrawCurrencyTitle")}
        >
          <WidthdrawCurrency
            currencys={wallets?.flat}
            onChange={(_value: any, option: any) => {
              changeWidthdraw(option?._index);
            }}
          />
        </FromItemPlus>

        <LoadingUI
          isLoading={isValidating}
          error={error}
          dataList={data}
          retryFunc={mutate}
          className="wallet-flat-loading-state"
        >
          <>
            <InternalWithdrawWayField
              configs={data?.configParams}
              onChange={changeType}
            />

            {selectedWithdrawType === 102 && (
              <div className="withdraw-method-section">
                <label className="method-label">
                  <span className="withdraw-required-mark">*</span>
                  <span>{t("Wallet.Method")}</span>
                </label>
                <PaymentMethodSelector
                  methods={getFilteredWithdrawChannels()}
                  selectedMethod={bankType}
                  onMethodSelect={setBankType}
                  className="withdraw-bank-selector"
                />
              </div>
            )}

            {selectedWithdrawType === 102 && !data?.userAccount?.pixCpf && (
              <WidthdrawPix
                data={data}
                widthdrawConfig={widthdrawConfig}
                currentWallet={currentWallet}
                form={form}
                formValidateRef={formValidateRef}
              />
            )}
            {selectedWithdrawType === 102 && data?.userAccount?.pixCpf && (
              <WidthdrawedPix
                data={data}
                widthdrawConfig={widthdrawConfig}
                currentWallet={currentWallet}
                form={form}
                formValidateRef={formValidateRef}
              />
            )}

            {selectedWithdrawType === 104 && (
              <div className="withdraw-bank-section">
                <div className="bank-selector-wrapper">
                  <label className="bank-selector-label">
                    <span className="withdraw-required-mark">*</span>
                    <span>{t("Wallet.Select Bank")}</span>
                  </label>
                  <BankSelector
                    value={selectedBank}
                    onChange={handleBankSelect}
                    placeholder={t("Wallet.Select Bank")}
                    withdrawType={104}
                    availableChannels={[104]}
                    bankCodeDataByChannel={{ 104: ghanaBankCode104 || [] }}
                  />
                </div>
              </div>
            )}

            {selectedWithdrawType === 104 && (
              <div className="withdraw-mobile-section">
                <FromItemPlus
                  field={"mobile"}
                  label={t("Wallet.Mobile Number")}
                  className="withdraw-mobile-item"
                  rules={[
                    {
                      required: true,
                      message: t("Wallet.Please enter mobile number"),
                    },
                    {
                      validator: (value, cb) => {
                        if (value && (value.length < 8 || value.length > 10)) {
                          return cb(t("Wallet.Mobile number must be"));
                        }
                        return cb();
                      },
                    },
                  ]}
                >
                  <MobileInput disabled={true} />
                </FromItemPlus>
                <div className="important-notice">
                  {t("Wallet.WithdrawPhoneNotice")}
                </div>
              </div>
            )}

            {selectedWithdrawType === 104 && (
              <WidthdrawPix
                data={data}
                widthdrawConfig={widthdrawConfig}
                currentWallet={currentWallet}
                form={form}
                formValidateRef={formValidateRef}
              />
            )}
          </>
        </LoadingUI>
      </FormUI>

      <ButtonUI
        className={`widthdraw-btn`}
        type="primary"
        onClick={onClickWidthdraw}
      >
        {t("Wallet.Withdraw")}
      </ButtonUI>

      {showConfirmModal && (
        <WithdrawConfirmModal
          visible={showConfirmModal}
          onClose={handleWithdrawClose}
          onConfirm={handleWithdrawConfirm}
          withdrawData={pendingWithdrawData}
        />
      )}
    </div>
  );
};

export default FlatWithdrawGhana;
